import { z } from "zod";
import { CatalogItemSort } from "../catalogItem";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum CatalogItemColumn {
    NAME = "name",
    DESCRIPTION = "description",
    UNIT_PRICE = "unitPrice",
    CLASS = "class",
    ENTITY = "entity",
    ACCRUAL_ACCOUNT = "accrualAccount",
    RECEIVABLES_ACCOUNT = "receivablesAccount",
    LAST_UPDATED = "lastUpdated",
    INVOICE_COUNT = "invoiceCount",
    TEMPLATE_COUNT = "templateCount",
    ACTIONS = "actions",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.NAME),
});

const DescriptionColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.DESCRIPTION),
});

const UnitPriceColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.UNIT_PRICE),
});

const ClassColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.CLASS),
});

const EntityColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.ENTITY),
});

const AccrualAccountColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.ACCRUAL_ACCOUNT),
});

const ReceivablesAccountColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.RECEIVABLES_ACCOUNT),
});

const LastUpdatedColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.LAST_UPDATED),
});

const InvoiceCountColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.INVOICE_COUNT),
});

const TemplateCountColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.TEMPLATE_COUNT),
});

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(CatalogItemColumn.ACTIONS),
});

export const CatalogItemViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.CATALOG_ITEM),
    // Active column sort. Held on the view so it persists alongside column
    // layout via the workspace-user view cache (no parallel sort state).
    sort: z.nativeEnum(CatalogItemSort).optional(),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            DescriptionColumnSchema,
            UnitPriceColumnSchema,
            ClassColumnSchema,
            EntityColumnSchema,
            AccrualAccountColumnSchema,
            ReceivablesAccountColumnSchema,
            LastUpdatedColumnSchema,
            InvoiceCountColumnSchema,
            TemplateCountColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type CatalogItemView = z.infer<typeof CatalogItemViewSchema>;
